import React from 'react'
const Carousel = () => {
    return (
        <>
            <section className="carousel">
                <div className='container'>
                    <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <div className="box text-center">
                                    <h3>01 Muhammad Rizwan</h3>
                                    <div className="col-lg-8 offset-lg-2">
                                        <p>Client testimonials often highlight specific benefits, outcomes, or exceptional customer service that clients have received. They can speak to the effectiveness of a product, the professionalism of a service provider, or the overall satisfaction of the customer. By sharing their positive experiences, clients help to build a positive reputation for the business and create a sense of confidence among prospective clients.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="box text-center">
                                    <h3>02 Muhammad Rizwan</h3>
                                    <div className="col-lg-8 offset-lg-2">
                                        <p>When crafting a compelling testimonial paragraph, it is important to include specific details and anecdotes that demonstrate the impact or transformation the client experienced. This adds authenticity and credibility to the testimonial. Additionally, including the client's name, profession, and any relevant affiliations can further enhance the trustworthiness of the testimonial.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="box text-center">
                                    <h3>03 Muhammad Rizwan</h3>
                                    <div className="col-lg-8 offset-lg-2">
                                        <p>Ultimately, client testimonials act as powerful marketing tools by showcasing the real-life success stories of satisfied customers. They have the ability to influence the buying decisions of potential customers and contribute to the overall growth and success of a business.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Carousel